const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function getPopupFocusableElements(dialog) {
  return Array.from(dialog?.querySelectorAll(FOCUSABLE_SELECTOR) || []).filter(
    element => !element.disabled,
  );
}

export function trapPopupFocus(event, dialog, activeElement) {
  const focusableElements = getPopupFocusableElements(dialog);
  if (focusableElements.length === 0) return false;

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  if (event.shiftKey && activeElement === firstElement) {
    event.preventDefault();
    lastElement.focus();
    return true;
  }
  if (!event.shiftKey && activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
    return true;
  }
  return false;
}

export function focusPopupEntry(entryElement) {
  entryElement?.focus();
}

export function restorePopupFocus(previousElement) {
  if (previousElement?.isConnected) previousElement.focus();
}

export function beginPopupNavigation(state) {
  if (state.isNavigating) return false;
  state.isNavigating = true;
  return true;
}

export { FOCUSABLE_SELECTOR };
